var $ = require('jquery');
/**
 * KPI Tracking functionality for the toolbar search feature
 *
 * @depends search.js
 */
(function() {
    'use strict';

    var KPI_TRACKING_KEY_PRESS_TIMEOUT = 500,
        KPI_TRACKING_RESULTS_VIEW_TIMEOUT = 7000;

    var SearchKpi = Klazz.extend({
        searchPhrase: null,
        lastSearchPhrase: null,
        kpiTrackingKeyPressTimer: null,
        kpiTrackingResultsViewTimer: null,

        init: function() {
            $(document)
                .bind('diy-editor-search-focus', $.proxy(this.trackFocus, this))
                .bind('diy-editor-search-search', $.proxy(this.trackSearch, this))
                .bind('diy-editor-search-resultclick', $.proxy(this.trackResult, this))
                .bind('diy-editor-search-helplinkclick', $.proxy(this.trackNoResult, this))
                .bind('diy-editor-search-showmoreclick', $.proxy(this.trackMoreResults, this));
        },

        getSearchPhrase: function() {
            return this.searchPhrase;
        },

        setSearchPhrase: function(searchPhrase) {
            this.searchPhrase = searchPhrase;
        },

        getLastSearchPhrase: function() {
            return this.lastSearchPhrase;
        },

        setLastSearchPhrase: function(searchPhrase) {
            this.lastSearchPhrase = searchPhrase;
        },

        isRepeatedSearch: function() {
            return $.trim(this.lastSearchPhrase) == $.trim(this.searchPhrase);
        },

        trackFocus: function() {
            /* KPI Tracking - When the user has focus on the search field */
            $(document).trigger('diy-editor-makeWebsiteFit', {
                name: 'Search',
                condition: 'Visited'
            });
        },

        trackSearch: function(e, data) {
            this.setSearchPhrase(data.searchPhrase);

            if (this.kpiTrackingKeyPressTimer) {
                clearTimeout(this.kpiTrackingKeyPressTimer);
            }
            if (this.kpiTrackingResultsViewTimer) {
                clearTimeout(this.kpiTrackingResultsViewTimer);
            }

            // After some time since the last key pressed, track that we made
            // a search
            this.kpiTrackingKeyPressTimer = setTimeout($.proxy(function() {
                var triggeredEventName = (this.isRepeatedSearch())?
                            'diy-editor-repeatedSearchExecuted':'diy-editor-searchExecuted';
                $(document).trigger(triggeredEventName, {
                    'searchPhrase': this.getSearchPhrase(),
                });
                this.setLastSearchPhrase(data.searchPhrase);
            }, this), KPI_TRACKING_KEY_PRESS_TIMEOUT);

            // After some time since the search was made, if nothing was clicked
            // from the results, track this
            if (data.resultsFound) {
                this.kpiTrackingResultsViewTimer = setTimeout($.proxy(function() {
                    $(document).trigger('diy-editor-searchResultNotClicked', {
                        'searchPhrase': this.getSearchPhrase()
                    });
                }, this), KPI_TRACKING_RESULTS_VIEW_TIMEOUT);
            }
        },

        trackResult: function(e, data) {
            // We clicked a result, we reset the click timeout timer
            if (this.kpiTrackingResultsViewTimer) {
                clearTimeout(this.kpiTrackingResultsViewTimer);
            }

            // Track that we clicked on a search result
            $(document).trigger('diy-editor-searchResultClicked', {
                'searchPhrase': this.getSearchPhrase(),
                'categoryId': data.categoryId,
                'resultIndex': data.resultIndex + 1 // make sure it starts from 1 rather than 0
            });
        },

        trackNoResult: function(e, data) {
            // Track that we clicked on a help link in the "no results found"
            // layer
            $(document).trigger('diy-editor-searchNoResultsHelpLinkClick', {
                'searchPhrase': this.getSearchPhrase(),
                'helpLinkId': data.helpLinkId
            });
        },

        trackMoreResults: function(e, data) {
            $(document).trigger('diy-editor-generic-linkInteraction', {
                actionName: 'ShowMoreResults'
            });
        }
    });


    module.exports = SearchKpi;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/search/search.tracking.js
 ** module id = 854
 ** module chunks = 0
 **/